/** GET /api/me/tester-license (#1886). */
export interface MyTesterLicense {
    state: "current" | "expiring" | "expired" | "none";
    number: string | null;
    expiresOn: string | null;
    daysLeft: number | null;
    /** "9/30" (or "9/30/2025" in another year), as the server writes it. */
    expiresLabel: string | null;
    isHelper: boolean;
    warnDays: number;
}

export interface TesterLicenseNoticeCopy {
    tone: "amber" | "red";
    headline: string;
    body: string;
}

/** What the tech reads, or null when there's nothing to say. */
export function testerLicenseNoticeCopy(lic: MyTesterLicense): TesterLicenseNoticeCopy | null {
    if (lic.isHelper) return null;
    if (lic.state === "expired") {
        return {
            tone: "red",
            headline: `Your backflow license expired${lic.expiresLabel ? ` on ${lic.expiresLabel}` : ""}.`,
            body: "Renew it and send the new card to the office. You can't submit test reports until the office enters it.",
        };
    }
    if (lic.state === "expiring") {
        const d = lic.daysLeft ?? 0;
        const when = d <= 0 ? "today" : d === 1 ? "tomorrow" : `in ${d} days`;
        return {
            tone: "amber",
            headline: `Your backflow license expires ${when}${lic.expiresLabel ? ` (${lic.expiresLabel})` : ""}.`,
            body: "Renew it and send the new card to the office. Once it expires you can't submit test reports.",
        };
    }
    return null;
}
